<div class="textarea-field" [ngClass]="{ readonly: readonly, disabled: disabled }">
  <label *ngIf="label" for="{{ id }}" class="textarea-field-label">
    <span class="textarea-field-label-border-left"></span>
    <span class="textarea-field-label-content">{{ formattedLabel }}</span>
    <span class="textarea-field-label-border-right"></span>
  </label>

  <textarea
    #fieldElement
    type="text"
    id="{{ id }}"
    name="{{ name }}"
    [attr.maxlength]="maxlength"
    [disabled]="disabled"
    [readonly]="readonly"
    (input)="onChange()"
    (blur)="onBlur()"
    class="textarea-field-element"
  ></textarea>

  <label *ngIf="maxlength" for="{{ id }}" class="textarea-field-length"
    >Up to {{ maxlength }} characters</label
  >

  <ng-content #fieldMessages select="[fieldMessages]"></ng-content>
</div>
